import type { FunctionComponent } from 'react';
import { Flame } from '../../../Icon';
import * as styles from './BestValueBadge.module.scss';

export const BUTTON_LABEL = 'Best Value';

const BestValueBadge: FunctionComponent = () => (
  <div className={styles.bestValueBtn}>
    <Flame fill="#fff" />
    <span>{BUTTON_LABEL}</span>
  </div>
);

export default BestValueBadge;
